export const pre_calc_title =
    <section class="one-ekran">
        <div class="conteiner">
            <div class="one-ekran-contant">
                <h1 class="h1">Страхование ипотеки</h1>
                <p class="one-ekran-contant-text">Минимальная цена на обязательное <br />ипотечное страхование</p>
            </div>
        </div>
    </section>